import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Credentials} from '../model/user/credentials';
import {BackendApi, localhost} from '../config/backend-api';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {EntityDto} from '../model/user/EntityDto';
import {KeepAliveService} from './keep-alive.service';
import {User} from '../model/user/User';
import {MatSnackBar} from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private httpClient: HttpClient, private keepAliveService: KeepAliveService,
              private router: Router,
              private snackBar: MatSnackBar) { }

  getToken(): string {
    return JSON.parse(localStorage.getItem('jwt'));
  }

  public login(credentials: Credentials): Observable<any> {
    return this.httpClient.post<EntityDto>(localhost + BackendApi.LOGIN, credentials);
  }

  recoverPassword(form) {
    console.log(form);
    return this.httpClient.post(localhost + BackendApi.RECOVER_PWD, form, {responseType: 'text', observe: 'response'})
      .subscribe(d => {
          if (d.status === 200) {
            this.router.navigateByUrl('/success').then(() => setTimeout(() => location.replace('/startup'), 1500));
          }
        },
        error => {
          console.log(error);
          this.router.navigateByUrl('/error').then(() => setTimeout(() => location.replace('/startup'), 1500));
        });
  }

  changePasswordRequest(form) {
    console.log(form);
    return this.httpClient.post(localhost + BackendApi.CHANGE_PWD, form, {responseType: 'text', observe: 'response'})
      .subscribe(d => {
          if (d.status === 200) {
            this.router.navigateByUrl('/success').then(() => setTimeout(() => location.replace('/startup'), 1500));
            console.log(d);
          }
        },
        error => {
          this.router.navigateByUrl('/error').then(() => setTimeout(() => location.replace('/startup'), 1500));
          console.log(error);
        });
  }

  changePassword(form, uuid: string) {
    console.log(form);
    const date = Math.round(Date.now() / 1000);
    console.log(date);
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.CONFIRM_CHANGE_PWD + uuid + '/' + date, form, {responseType: 'text', observe: 'response'});
  }


  subscribeToTopic(email: string, token: string) {
    const subscriptionPayload = {
      email,
      token
    };
    console.log(subscriptionPayload);

    return this.httpClient.post(localhost + BackendApi.SUBSCRIBE_TO_TOPIC, subscriptionPayload, {responseType: 'text', observe: 'response'})
      .subscribe(d => {
        if (d.status === 200) {
          console.log('subscribed with success');
        }
      });
  }

  expired() {
    const now = new Date();
    const expirationTime = JSON.parse(localStorage.getItem('expirationTime'));

    if (now.getTime() > expirationTime + 60000) {
      console.log('expired');
      const token = localStorage.getItem('firebase-token');
      localStorage.clear();
      localStorage.setItem('firebase-token', token);
      return true;
    }

    return false;
  }

  keepAliveSession() {
      const now = new Date().getTime();
      const expiration = JSON.parse(localStorage.getItem('expirationTime'));
      console.log('Starting...', expiration, now);
      const expirationDate = new Date(expiration);
      const nowDate = new Date(now);
      console.log('Expiration date', expirationDate);
      console.log('Now date', nowDate);
      setInterval(() => {
          this.keepAliveService.keepAlive();
        }, 900000);
  }

  keepAliveSessionAfterRefresh() {
    this.pullUpdates();
    const now = new Date().getTime();
    const expiration = JSON.parse(localStorage.getItem('expirationTime'));
    console.log('After refresh...', expiration, now, Math.round((expiration - now)));
    setTimeout(() => {
      this.keepAliveService.keepAlive();
      this.keepAliveSession();
    }, Math.round((expiration - now)));
  }

  pullUpdates() {
    const user = JSON.parse(localStorage.getItem('user'));
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<User>(localhost + BackendApi.PULL_UPDATES + user.email + '/' + user.ssn, {observe: 'response', responseType: 'json'})
    .subscribe(res => {
        if (res.status === 200) {
          localStorage.setItem('user', JSON.stringify(res.body));
          console.log('new user', res.body);
        }
      },
      error => {
        console.error(error, 'Failed request');
      }
    );
  }

  isPatientEnabled(user: User) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.get<boolean>(localhost + BackendApi.CHECK_PATIENT_ACTIVATION + user.email, {observe: 'response', responseType: 'json'});
  }

  enablePatient(user: User, result: string) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.ENABLE_PATIENT + user.email, result, {observe: 'response', responseType: 'text'})
      .subscribe(res => {
          if (res.status === 200) {
            if (result.localeCompare('true') === 0) {
              const message = 'Paziente abilitato con successo!';
              this.openSnackBar(message);
              localStorage.removeItem('enabled');
            } else {
              const message = 'Non hai acconsentito al trattamento dei dati personali. Il tuo account verrà eliminato.';
              this.openSnackBar(message);
            }
          }
        },
        error => {
          console.error(error, 'Failed request');
        }
      );
  }

  openSnackBar(message: string) {
    this.snackBar.open(message, 'Chiudi', {duration: 3000});
  }

  calcUsageTime() {
    const user = JSON.parse(localStorage.getItem('user'));
    console.log(user.email);
    console.log('URL:', localhost + BackendApi.USAGE_TIME + user.email);
    return this.httpClient.get<any>(localhost + BackendApi.USAGE_TIME + user.email).subscribe(status => {
      console.log('done');
    });
  }

  logout() {
    return this.calcUsageTime();
  }

  changePasswordAuth(form: any) {
    // tslint:disable-next-line:max-line-length
    return this.httpClient.post(localhost + BackendApi.CHANGE_PWD_AUTH, form, {responseType: 'text', observe: 'response'});

  }
}
